

































































































































import { Vue, Component } from 'vue-property-decorator'
import { Draggable, DraggableValue } from 'draggable-vue-directive'
import { Base64 } from 'js-base64'
@Component({
  directives: {
    Draggable,
  },
})
export default class DragContainer extends Vue {
  draggableWithBoundries: DraggableValue = { onDragEnd: this.onDragEnd }
  draggableTextWithBoundries: DraggableValue = { onDragEnd: this.onTextDragEnd }
  // private containerWidth = 400
  // private imgUrl = ''
  // private watermarkUrl =
  //   'digitalAsset/images/brand/logo_of_whoo.jpg?x-oss-process=image/resize,w_150'
  private ossDomain="https://static.connext.net.cn/"
  private imgConfig = {
    originalUrl:
      'digitalAsset%2Fimages%2Ftest%2F%E7%9C%BC%E9%9C%9C_06%E8%8A%B1%E7%8C%AE%E5%85%89%E5%BD%A9%E7%B4%A7%E9%A2%9C%E7%9C%BC%E9%9C%9C_1600_04-1.jpg',
    originalWidth: 400,
    originalHeight: 0,
    watermarkUrl: 'digitalAsset/images/brand/logo_of_whoo.jpg',
    waterWidth: 150,
    waterHeight: 0,
  }
  private watermarkPostionX = 0
  private watermarkPostionY = 0

  private watermarkText = 'test'
  private textColor = 'ffffff'
  private textSize = 20
  private textPostionX = 0
  private textPostionY = 0
  private fontFamily ='ZmFuZ3poZW5naGVpdGk'

  get base64Url(): string {
    return Base64.encode(
      `${this.imgConfig.watermarkUrl}?x-oss-process=image/resize,w_${this.imgConfig.waterWidth}`
    )
    // return (typeof this.currentSearch.searchValue === 'string') ? undefined : this.currentSearch.searchValue;
  }
  get base64Text(): string {
    return Base64.encode(this.watermarkText, true)
    // return (typeof this.currentSearch.searchValue === 'string') ? undefined : this.currentSearch.searchValue;
  }
  get watermarkTextStyle(): any {
    return { 'font-size': this.textSize + 'px', color: `#${this.textColor}` }
    // return (typeof this.currentSearch.searchValue === 'string') ? undefined : this.currentSearch.searchValue;
  }
  get OSSUrl(): string {
    return (
      `${this.ossDomain + this.imgConfig.originalUrl}?` +
      `x-oss-process=image/resize,w_${this.imgConfig.originalWidth}/watermark,image_${this.base64Url},` +
      `g_nw,x_${this.watermarkPostionX},y_${this.watermarkPostionY}` +
      `/watermark,type_${this.fontFamily},text_${this.base64Text},color_${this.textColor},size_${this.textSize},g_nw,x_${this.textPostionX},y_${this.textPostionY}`
    )
  }

  get mLeft(): number {
    return (this.$refs.bounder as HTMLElement).getBoundingClientRect().left
  }
  get mTop(): number {
    return (this.$refs.bounder as HTMLElement).getBoundingClientRect().top
  }
  mounted(): void {
    this.draggableWithBoundries.boundingElement = this.$refs
      .bounder as HTMLElement
    this.draggableWithBoundries.boundingRectMargin = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    }
    this.draggableTextWithBoundries.boundingElement = this.$refs
      .bounder as HTMLElement
    this.draggableTextWithBoundries.boundingRectMargin = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    }
  }
  private imgLoaded(key: string) {
    // 图片地址
    var img_url = `${this.ossDomain+this.imgConfig.watermarkUrl}?x-oss-process=image/resize,w_${this.imgConfig.waterWidth}`
    if (key === 'original') {
      img_url = `${this.ossDomain+this.imgConfig.originalUrl}?x-oss-process=image/resize,w_${this.imgConfig.originalWidth}`
    }
    // 创建对象
    var img = new Image()
    // 改变图片的src
    img.src = img_url
    // 加载完成执行
    img.onload = () => {
      // 打印
      // alert('width:' + img.width + ',height:' + img.height)
      // this.imgConfig.waterWidth=img.width
      key === 'original'
        ? (this.imgConfig.originalHeight = img.height)
        : (this.imgConfig.waterHeight = img.height)
    }
  }
  private onDragEnd(positionDiff: unknown, absolutePosition: any, event: any) {
    console.log('positionDiff', positionDiff)
    console.log('absolutePosition', absolutePosition)
    console.log('event', event)
    this.watermarkPostionX = parseInt(
      (absolutePosition.left - this.mLeft).toString()
    )
    this.watermarkPostionY = parseInt(
      (absolutePosition.top - this.mTop).toString()
    )
  }
  private onTextDragEnd(
    positionDiff: unknown,
    absolutePosition: any,
    event: any
  ) {
    console.log('positionDiff', positionDiff)
    console.log('absolutePosition', absolutePosition)
    console.log('event', event)
    this.textPostionX = parseInt(
      (absolutePosition.left - this.mLeft).toString()
    )
    this.textPostionY = parseInt((absolutePosition.top - this.mTop).toString())
  }
}
